module.exports = __webpack_public_path__ + "media/categories/5006-b13cf324.svg";